import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { SupplierBankAccount, SupplierBankAccountCreate, SupplierBankAccountFilter } from '../data/supplierBankAccount';

export function createSupplierBankAccountService(client: AxiosInstance) {
  return createCrudService<SupplierBankAccount, SupplierBankAccountCreate, SupplierBankAccountFilter>(
    client,
    '/purchase/SupplierBankAccount',
    'id',
  );
}

export type SupplierBankAccountService = CrudService<SupplierBankAccount, SupplierBankAccountCreate, SupplierBankAccountFilter>;
